import HorizontalGallery from "../components/horizontalGallery";
function Toppick() {
  const images = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+Life+Gives+You+Tangerines%2C+%E1%84%91%E1%85%A9%E1%86%A8%E1%84%8A%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%A1%E1%86%BB%E1%84%89%E1%85%AE%E1%84%83%E1%85%A1+(2025).jpeg",
      alt: "When Life Gives You Tangerines",
      title: "When Life Gives You Tangerines",
      rating: "5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/%D0%9A%D0%B0%D0%BA+%D0%B2+%D0%BA%D0%B8%D0%BD%D0%BE_Melo+Movie+(Drama%2C+2025%2C+%E1%84%86%E1%85%A6%E1%86%AF%E1%84%85%E1%85%A9%E1%84%86%E1%85%AE%E1%84%87%E1%85%B5).jpeg",
      alt: "Melo movie",
      title: "Melo movie",
      rating: "3.5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(10).jpeg",
      alt: "My dearest nemesis",
      title: "My dearest nemesi",
      rating: "2.9",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/LOVE+SCOUT.jpeg",
      alt: "Love scout",
      title: "Love scout",
      rating: "3.6",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+the+Stars+Gossip_.jpeg",
      alt: "When the star gossip",
      title: "When the star gossip",
      rating: "3",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(6).jpeg",
      alt: "Friendly rivalry",
      title: "Friendly rivalry",
      rating: "3.5",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/StudyGroup.jpeg",
      alt: "Study group",
      title: "Study group",
      rating: "4.5",
    },
  ];

  const bestOf2024 = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Squid+Game+2.jpeg",
      alt: "Squid game season 2",
      title: "Squid game season 2",
      rating: "4.5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(11).jpeg",
      alt: "Brewing love",
      title: "Brewing love",
      rating: "3.2",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/lovelyrunner.jpeg",
      alt: "Lovely runner",
      title: "Lovely runner",
      rating: "4.2",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(12).jpeg",
      alt: "Mr Plankton",
      title: "Mr Plankton",
      rating: "3.5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/The+Trunk+k-drama+2024.jpeg",
      alt: "Trunk",
      title: "Trunk",
      rating: "3",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Family+by+Choice.jpeg",
      alt: "Family by choice",
      title: "Family by choice",
      rating: "3.2",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(13).jpeg",
      alt: "Light shop",
      title: "Light shop",
      rating: "4.6",
    },
    {
      id: 8,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Yoo+yeon+seok+y+Chae+Soo-bin+cuando+el+tele%CC%81fono+suena.jpeg",
      alt: "When the phone rings",
      title: "When the phone rings",
      rating: "4.2",
    },
    {
      id: 9,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Soompi_+Latest+K-Pop%2C+K-Drama%2C+Korean+Entertainment+News+(2024).jpeg",
      alt: "Love next door",
      title: "Love next door",
      rating: "2.5",
    },
    {
      id: 10,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Doctor+Slump+K-drama+Official+Poster+Netflix.jpeg",
      alt: "Doctor slump",
      title: "Doctor slump",
      rating: "2.6",
    },
    {
      id: 11,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/153_+Twinkling+Watermelon.jpeg",
      alt: "Twinkling watermelon",
      title: "Twinkling watermelon",
      rating: "4.3",
    },
  ];

  const timelessClassic= [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Reply1988.jpeg",
      alt: "Reply 1988",
      title: "Reply 1988",
      rating: "5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+Life+Gives+You+Tangerines%2C+%E1%84%91%E1%85%A9%E1%86%A8%E1%84%8A%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%A1%E1%86%BB%E1%84%89%E1%85%AE%E1%84%83%E1%85%A1+(2025).jpeg",
      alt: "When life gives you tangerines",
      title: "When life gives you tangerines",
      rating: "5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/legend.jpeg",
      alt: "Legend of blue sea",
      title: "Legend of blue sea",
      rating: "4.9",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Strong+woman+Do+bong+Soon.jpeg",
      alt: "Strong girl boong soon",
      title: "Strong girl boong soon",
      rating: "5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/AlchemyOfSouls.jpeg",
      alt: "Alchemy of souls",
      title: "Alchemy of souls",
      rating: "4.6",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/U%CC%88zleti+Aja%CC%81nlat.jpeg",
      alt: "Business proposal",
      title: "Business proposal",
      rating: "4.7",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Truebeauty.jpeg",
      alt: "True beauty",
      title: "True beauty",
      rating: "4.6",
    },
    {
      id: 8,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/goblin.jpeg",
      alt: "Goblin",
      title: "Goblin",
      rating: "4.9",
    },
    {
      id: 9,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/CrashLandingonYouK-dramaOfficialposterNetflix.jpeg",
      alt: "Crash Landing on You",
      title: "Crash Landing on You",
      rating: "4.9",
    },
    {
      id: 10,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/twenty+five+twenty+one+poster.jpeg",
      alt: "Twenty five twenty one",
      title: "Twenty five twenty one",
      rating: "3.6",
    },
  ];

  return (
    <div>
      <header
        className="top-pick-header"
        style={{ display: "flex", alignItems: "center", color: "#800080" }}
      >
        <div
          style={{
            fontSize: "2.5em",
            fontWeight: "bold",
            margin: "0",
            marginRight: "5px",
          }}
        >
          Top picks
        </div>
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          className="ipc-icon ipc-icon--chevron-right-inline ipc-icon--inline ipc-title-link ipc-title-link-chevron"
          viewBox="0 0 24 24"
          fill="white"
          role="presentation"
        >
          <path d="M5.622.631A2.153 2.153 0 0 0 5 2.147c0 .568.224 1.113.622 1.515l8.249 8.34-8.25 8.34a2.16 2.16 0 0 0-.548 2.07c.196.74.768 1.317 1.499 1.515a2.104 2.104 0 0 0 2.048-.555l9.758-9.866a2.153 2.153 0 0 0 0-3.03L8.62.61C7.812-.207 6.45-.207 5.622.63z"></path>
        </svg>
      </header>

      <span
        style={{
          display: "block",
          color: "yellow",
          marginTop: "15px",
          fontSize: "20px",
        }}
      >
        Best of 2025 so far...
      </span>
      <HorizontalGallery images={images} />
      <span
        style={{
          display: "block",
          color: "yellow",
          marginTop: "15px",
          fontSize: "20px",
        }}
      >
        Best of 2024
      </span>
      <HorizontalGallery images={bestOf2024} />
      <span
        style={{
          display: "block",
          color: "yellow",
          marginTop: "15px",
          fontSize: "20px",
        }}
      >
        {" "}
        Timeless classics
      </span>
      <HorizontalGallery images={timelessClassic} />
    </div>
  );
}

export default Toppick;
